export default [
  {
    path: '',
    name: 'expenses-new',
    component: () => import('pages/expenses/new/index.vue'),
  },
  {
    path: 'details',
    name: 'expenses-new-details',
    component: () => import('pages/expenses/new/details.vue'),
  },
  {
    path: 'split',
    name: 'expenses-new-split',
    component: () => import('pages/expenses/new/split.vue'),
  },
]
